export default __webpack_public_path__ + "989beb0e1ef919c65f180977621b953c.png";